import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEye, faEyeSlash, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/internal/operators/first';
import { User } from '../../../../../modules/account/login/_models/user.model';
import { GlobalConstants } from '../../../../../../app/common/constants/global.constant';
import { DevicesConstants } from '../../../../../../app/core/routing/services/devices/constants/devices.constants';
import { DevicesService } from '../../../../../../app/core/routing/services/devices/devices.service';
import { CreateProfileService } from '../../../../../../app/core/routing/services/profile/create-profile.service';
import { AppGlobal } from '../../../../../core/state/app-global';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs';
import { CommonService } from '../../../../../../app/common/services/common.service';
import { GoogleAnalyticsService } from '../../../../../modules/google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-password-popup',
  templateUrl: './password-popup.component.html',
  styleUrls: ['./password-popup.component.scss']
})
export class PasswordPopupComponent implements OnInit {

  changePasswordForm: FormGroup = new FormGroup({});
  submitted = false;
  form: FormGroup = new FormGroup({});
  fieldTextType: boolean;
  fieldTextType2: boolean;
  displayEye: IconDefinition;
  payload;
  type: String; // For Master/ uninstall pwd ref
  successMessage;
  description;
  openModalPopup;
  isSuccess = true;
  retailerConfig: any;
  userRole: string;
  passwordLabel = DevicesConstants.DEVICE_PASSWORD_IS_REQUIRED;
  passwordErrorMessage = DevicesConstants.DEVICE_PASSWORD_ERROR_MESSAGE;
  passwordMatch = DevicesConstants.DEVICE_PASSWORD_MATCH;
  cancel = GlobalConstants.CANCEL;
  enterPasswordPlaceHolder = DevicesConstants.ENTER_TYPE_PASSWORD;
  confirmPasswordPlaceHolder = DevicesConstants.CONFIRM_TYPE_PASSWORD;
  passwordsDesc = DevicesConstants.MASTER_PASSWORD_ON_DEVICE;
  userId: string = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerId: string = sessionStorage.getItem(GlobalConstants.RETAILER_ID);
  @ViewChild('profileChangePasswordModal') modalContent: TemplateRef<PasswordPopupComponent>;
  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private modalService: NgbModal, 
    private fb: FormBuilder, 
    private deviceservice: DevicesService,
    private appGlobal: AppGlobal,
    private createProfileService: CreateProfileService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private cmnService: CommonService,
  ) {

    this.buildForm(fb);
  }
  ngOnInit() {
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.openModalPopup = false;
    this.appGlobal.$userAccount
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (userAccount: User) => {
        this.userRole = userAccount.role;
        if(this.checkRole()){
          this.retailerConfig = (userAccount.configurations !== undefined) ? JSON.parse(userAccount.configurations) : await this.cmnService.getRetailerConfig(this.userId,this.retailerId)
        }
      });
  }

  buildForm(fb) {
    this.form = fb.group({
      password: ['', [Validators.required, Validators.minLength(5)]],
      confirm_password: ['', [Validators.required, Validators.minLength(5)]]
    }, {
      validator: confirmPasswordValidator('password', 'confirm_password')
    });
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
    if (this.fieldTextType) {
      this.displayEye = faEyeSlash;
    } else if (!this.fieldTextType) {
      this.displayEye = faEye;
    }
  }

  toggleFieldTextType2() {
    this.fieldTextType2 = !this.fieldTextType2;
    if (this.fieldTextType2) {
      this.displayEye = faEyeSlash;
    } else if (!this.fieldTextType2) {
      this.displayEye = faEye;
    }
  }

  get f() {
    return this.form.controls;
  }

  async submit() {
    this.openModalPopup = true;
    //IIT2-4921
    let updatedRetailData:any = await this.fetchRetailHQData();
    if(updatedRetailData?.retailer?.configurations){
      this.retailerConfig = JSON.parse(updatedRetailData?.retailer?.configurations);
    }
    //IIT2-4921 end
    let otherSettingsJson:any = { 
      isBrandColorEnabled : this.checkRole() ? 
      (this.retailerConfig?.bandColor !== undefined ? this.retailerConfig?.bandColor : false) :
      false, 
      brandColor : this.checkRole() ? 
        (this.retailerConfig?.bgcolor ? this.retailerConfig?.bgcolor : "") : "",
      enable3DMarkFeature : this.checkRole() ? 
        (this.retailerConfig?.enable3DMarkFeature !== undefined ? this.retailerConfig?.enable3DMarkFeature : false) :
        false, 
      enableMobileSocket : GlobalConstants.SOCKET_DEFAULT_VALUE,
      pollFrequency : this.checkRole() ? 
      (this.retailerConfig?.pollFrequency ? this.retailerConfig?.pollFrequency : GlobalConstants.POLL_FREQ_DEFULT_VALUE) :
      GlobalConstants.POLL_FREQ_DEFULT_VALUE
    };
    if(
      (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) && 
      this.retailerConfig?.displayDeviceRetailerId?.length
    ){
      otherSettingsJson.displayDeviceRetailerId = this.retailerConfig?.displayDeviceRetailerId;
    }

    if (this.type === DevicesConstants.DEVICE_MASTER) {
      this.payload = {
        settings: JSON.stringify({
          masterPwd: this.form.value.confirm_password,
          otherSettings: otherSettingsJson
        })
      };
      this.googleAnalyticsService.pushPasswordChanges(GlobalConstants.PRIMARY_PASSWORD_CHANGES_PUSHED); // IIT2-5312
    } else {
      this.payload = {
        settings: JSON.stringify({
          uninstallPwd: this.form.value.confirm_password,
          otherSettings: otherSettingsJson
        })
      };
      this.googleAnalyticsService.pushPasswordChanges(GlobalConstants.UNINSTALL_PASSWORD_CHANGES_PUSHED); // IIT2-5312
    }

    this.deviceservice.deviceSettingPatchReq(JSON.stringify(this.payload), this.retailerId)
      .pipe(first())
      .subscribe(response => {
      });
    this.isSuccess = false;
  }
  open(data) {

    this.buildForm(this.fb);
    this.type = data;
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
    if (this.type === DevicesConstants.DEVICE_MASTER) {
      this.passwordsDesc = DevicesConstants.MASTER_PASSWORD_ON_DEVICE;
      this.successMessage = DevicesConstants.SUCCESS_MASTER_PASSWORD;
      this.description = DevicesConstants.SUCCESS_MASTER_PASSWORD_DESC;
    } else {
      this.passwordsDesc = DevicesConstants.UNINSTALL_PASSWORD_ON_DEVICE;
      this.successMessage = DevicesConstants.SUCCESS_UNINSTALL_PASSWORD;
      this.description = DevicesConstants.SUCCESS_UNINSTALL_PASSWORD_DESC;
    }

  }

  close() {
    this.modalRef.close();
  }

  dismiss() {
    this.openModalPopup = false;
    this.modalRef.dismiss();
    this.isSuccess = true;
  }
  //IIT2-4921
  fetchRetailHQData(){
    return new Promise((resolve,reject) => {
      if (this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ) {
        this.createProfileService.getUserRoleData(this.userId, this.retailerId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(data => {
            resolve(data);
          })
      }else{
        resolve({});
      }
    })
  }
  //To avoid repeated code.
  checkRole(){
    if(this.userRole === GlobalConstants.RETAIL_HQ_USER || this.userRole === GlobalConstants.STORE_USER || this.userRole === GlobalConstants.REGIONALHQ){
      return true;
    }else{
      return false;
    }
  }
  //IIT2-4921 end
}
const confirmPasswordValidator = (controlName: string, matchingControlName: string) =>
  (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
